var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-breadcrumb',{attrs:{"separator-class":"el-icon-arrow-right"}},_vm._l((_vm.matchedRouter),function(route){return _c('el-breadcrumb-item',{key:route.name,attrs:{"to":route.path}},[_vm._v(_vm._s(route.meta.name))])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }